export default "__VITE_ASSET__CGo1Wa2S__"